
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M505.94 107.172c1.961-44.464-45.615-42.539-43.132-42.539H48.642c3.136 0-42.152-3.886-42.642 42.539v290.229c0 27.524 22.498 50.045 49.994 50.045h399.952c27.497 0 49.994-22.521 49.994-50.045V107.172zM255.971 281.286L48.496 111.168h414.951L255.971 281.286z"}})])
          )
        }
      }
    